import React, { useContext } from 'react';
import {
  StyledInaccessible,
  StyledInaccessibleWrapper,
  StyledInaccessibleContent,
  StyledInaccessibleImage,
  StyledInaccessibleHeader,
} from '../Styled';
import AuthContext from '../../contexts/authContext';
import boy from '../../assets/boy.png';

interface IComingSoon {
  stageNotReady?: boolean;
}

export const ComingSoon: React.FC<IComingSoon> = (props): JSX.Element => {
  const { stageNotReady } = props;

  const { isTrialAccess } = useContext(AuthContext);

  const message =
    'We are scooting as fast as we can to get this to you.' +
    (stageNotReady ? ' When the series is ready, you can purchase from our website.' : '');

  return (
    <StyledInaccessibleWrapper data-testid="coming-soon" withBanner={isTrialAccess}>
      <StyledInaccessible height="251px">
        <StyledInaccessibleContent width="236px">
          <StyledInaccessibleHeader margin="10px 0px 16px 0px">Coming soon!</StyledInaccessibleHeader>
          <p>{message}</p>
        </StyledInaccessibleContent>
        <StyledInaccessibleImage src={boy as string} alt="boy" height="265px" />
      </StyledInaccessible>
    </StyledInaccessibleWrapper>
  );
};
